import React from 'react';
import { translate } from '../Services/translation';

const StockStatusTag = ({ description, stockStatusType }) => {
  const getStyleClass = (stockStatusType) => {
    let styleClass = '';
    switch (stockStatusType) {
      case 1:
        styleClass = 'is-in-stock';
        break;
      case 2:
        styleClass = 'temporary-sold-out';
        break;
      case 3:
        styleClass = 'incoming';
        break;
      case 4:
        styleClass = 'order-item';
        break;
      case 5:
        styleClass = 'get-in-contact';
        break;
      default:
        break;
    }
    return styleClass;
  };
  return (
    <div
      className={` [ stock-status stock-status--${getStyleClass(
        stockStatusType
      )} ] [ text-small lh-2 color-grey-900 d-flex align-center] `}
    >
      {stockStatusType == 1 ? (
        <i className="ph-check-circle-fill"></i>
      ) : (
        <i className="ph-warning-circle-fill"></i>
      )}
      {translate(description)}
    </div>
  );
};

export default StockStatusTag;
